import axios from "axios";
import { Util } from "./Util";

const util = new Util();
export default axios.create({
  baseURL: util.baseUrl,
});
